import React, { Fragment} from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Schedule = (props) => {
  return (
    <Fragment>
      <span className="boldText cbdmdBlueText">
        <FontAwesomeIcon icon="calendar-alt" className="mr-2" />
        Next Scheduled {props.title} Date:
      </span>
      {props.scheduledMaintenance !== null ? (
        <div className="ml-2">
          <span className="mr-2">{moment(props.scheduledMaintenance.date).format("M/DD/YYYY")}</span>
          <span className=""><FontAwesomeIcon icon="trash-alt" title={`Delete Scheduled ${props.title}`} className="cbdmdDangerText cursor"
            onClick={() => props.deleteScheduledWork(props.scheduledMaintenance.id, props.title)} />
          </span>
        </div>
      ) : (
          <div>
            <DatePicker
              selected={props.nextScheduledDate}
              className="form-control pageTitleItem float-right"
              placeholderText="Select a date"
              onChange={(e) => props.onDateChange(e, `nextScheduled${props.title}Date`, props.maintenanceTypeId)}
              disabled={props.disabled}
              minDate={new Date()}
            />
          </div>
        )}
    </Fragment>
  );
};

export default Schedule;


// WEBPACK FOOTER //
// ./src/components/Schedule.js